import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/uncooked_crouton.png";
import cooked from "../../assets/images/ingredients/Cooked_crouton.png";

const Crouton = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Crouton"
            image={[raw, cooked]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Crouton;